import { HeaderMenu, IHeaderMenu } from 'components/guide/menu/HeaderMenu';
import { useContext, useEffect, useState } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const EventMenu = (props: Props): JSX.Element => {
    const ctxEventView = useContext(CtxEventView);

    const order = ctxEventView?.eventData.eventInfo.order.wide;

    const [selectedItem, setSelectedItem] = useState<string | null>(null);

    const items: IHeaderMenu[] = order.map((item) => {
        if (item === 'home') {
            return {
                title: Localization.HOME,
                iconSet: 'far',
                iconName: 'home',
                link: 'about'
            };
        } else if (item === 'map') {
            return {
                title: Localization.MAP,
                iconSet: 'far',
                iconName: 'location-dot',
                link: 'map'
            };
        } else if (item === 'program') {
            return {
                title: ctxEventView.programTitleShort,
                iconSet: 'far',
                iconName: 'clock',
                link: 'program'
            };
        } else if (item === 'information') {
            return {
                title: Localization.INFO,
                iconSet: 'far',
                iconName: 'info-circle',
                link: 'info'
            };
        } else {
            const otherEntities = ctxEventView.eventData.eventInfo.otherEntities;
            const find = otherEntities.find((entity) => entity.id === item);
            if (find) {
                return {
                    title: find.name,
                    iconSet: 'far',
                    iconName: find.icon,
                    link: find.id
                };
            }
        }
    });

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                // entries = entries.reverse();
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setSelectedItem(entry.target.id);
                    }
                });
            },
            {
                rootMargin: '0px 0px -50% 0px'
            }
        );

        items.map((item) => {
            const element = document.getElementById(item?.link);
            if (element) observer.observe(element);
        });

        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <S_EventMenu className={props.className}>
            <S_HeaderMenu
                selectedItem={selectedItem}
                logo={ctxEventView.eventData?.eventInfo?.logoUrl}
                items={items}
            />
        </S_EventMenu>
    );
};

const S_EventMenu = styled.div``;

const S_HeaderMenu = styled(HeaderMenu)``;
